export default __webpack_public_path__ + "icon-like-heart.b6bcfad9.png";